import(/* webpackMode: "eager" */ "/app/packages/tokyu-web/app/(pages)/[locale]/(home)/layout.tsx");
